@if (heading) {
  <h1 class="visually-hidden">{{ heading }}</h1>
}
<div id="sid-runtime">
  <div id="sid-content-runtime-frame" class="sid-content-frame text-center" (dialog-event)="onDialogEvent($event)"></div>
</div>

<!--<div class="text-center mt-2 p-3">
  <p>
    <a [routerLink]="'/dashboard'" class="text-primary" [innerHtml]="'si_pts_chrome_dialog_back' | cmsText | async"></a>
  </p>
  <p>
    <a href="https://www.sustainableinteraction.se" target="_blank" class="text-dark">{{ 'si_pts_chrome_dialog_powered_by' | cmsText | async }}</a>
  </p>
</div>-->
